import { Page } from '@customer/components/layout/.';
import { VisitPublicStore } from "@customer/stores";
import { observer } from "mobx-react";
import React from "react";
import { useParams } from "react-router";
import { TreatmentPlanConsent } from "./TreatmentPlanConsent";

const ThankYou = () => <p>
    We have received your consent. Thank you! You can now close this tab.
</p>

export const ConsentContainer = observer(() => {
    const [visitStore] = React.useState<VisitPublicStore>(new VisitPublicStore());
    const [consentReceived, setConsentReceived] = React.useState(false);
    const { visitPublicId, consentTypePublicId } = useParams();

    React.useEffect(() => {
        if (visitPublicId)
            visitStore.fetchPublicVisit(visitPublicId);
    }, [visitStore, visitPublicId]);

    const onSave = async (signaturePhotoDataUrl: string) => {
        await visitStore.signConsent(visitPublicId!, consentTypePublicId!, signaturePhotoDataUrl)
            .then(setConsentReceived);
    }

    /* find the appropriate view for the specified consent type */
    const renderConsent = () => {
        switch (consentTypePublicId?.toUpperCase()) {
            case "12147E94-520F-4147-BA5A-5E69C22DF666": // hospital treatment plan consent
                return <TreatmentPlanConsent visit={visitStore.visit!} onSave={onSave} />;
            default: return <>The requested consent type was not found.</>;
        }
    }

    return <Page>
        <Page.Content>
            {/* {!visitStore.visit && <PulseLoader />} */}
            {consentReceived && <ThankYou />}
            {!consentReceived && visitStore.visit && renderConsent()}
        </Page.Content>
    </Page >
});
